import styled from 'styled-components';

export const BORDER_WIDTH = 20;

export default styled.canvas`
  border: ${BORDER_WIDTH}px solid rgb(187 187 187);
  border-radius: 50%;

  height: 100%;
  width: 100%;
`;
